import React from 'react'
import ServiceIcon from '../card-two-side/service-icon'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const BtnOperkinds = ({operkind,carId,carTitle}) => {
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();

  const message = (message,type) => {
    if (type==='warn') {
      toast.warning(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.success(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const clickHandler=()=>{
    if (user.expireDate === null && operkind.id != 1) {
        message('با اشتراک رایگان فقط سرویس تعویض روغن قابل تعریف است','warn');
        return;
    }

    navigate(`/add-service-step-3/${carId}/${carTitle}/${operkind.id}/${operkind.title}/${operkind.serviceType}/${operkind.mtbo}/${operkind.unit}`)
    // (res.id,res.title)
  }

  const getPeriodText = (mtbo,unit) => {
    if (unit === "Y") {
      return "دوره تکرار: " + mtbo + " سال" + " (پیش فرض)";
    } else {
      return "دوره تکرار: " + mtbo + " کیلومتر" + " (پیش فرض)";
    }
  };

  return (
    // <button 
    //   key={operkind.id} 
    //   type="button" 
    //   className="btn btn-lg btn-outline-secondary w-100 text-start p-3 mb-3"
    //   onClick={clickHandler}
    // >
    //   <div className="d-flex align-items-center">
    //     <div className="flex-shrink-0">
    //       <ServiceIcon categoryId={operkind.id} size={24} />
    //     </div>
    //     <div className="flex-grow-1 ms-3">
    //       <div className="d-flex flex-column">
    //         <span className="fw-bold">{operkind.title}</span>
    //         {/* <small className="text-muted">
    //           {operkind.serviceType} | تناوب پیش فرض: {operkind.mtbo} {operkind.unit}
    //         </small> */}
    //         <small className="text-muted">
    //           {operkind.serviceType === "time" ? "نوع سرویس: زمانی" : "نوع سرویس: کارکردی"}
    //         </small>
    //         <small className="text-muted">
    //           {getPeriodText(operkind.mtbo,operkind.unit)}
    //         </small>
    //       </div>
    //     </div>
    //   </div>
    // </button>

    <button 
      key={operkind.id} 
      type="button" 
      className="btn btn-outline-secondary w-100 text-start p-2"
      onClick={clickHandler}
      style={{ fontSize: "0.9rem" }}
    >
      <div className="d-flex align-items-center">
        <div className="flex-shrink-0">
          <ServiceIcon categoryId={operkind.id} size={20} />
        </div>
        <div className="flex-grow-1 ms-2">
          <div className="d-flex flex-column">
            <span className="fw-bold small">{operkind.title}</span>
            <small className="text-muted">
              {operkind.serviceType === "time" ? "نوع سرویس: زمانی" : "نوع سرویس: کارکردی"}
            </small>
            <small className="text-muted">
              {getPeriodText(operkind.mtbo,operkind.unit)}
            </small>
          </div>
        </div>
      </div>
    </button>

  )
}

export default BtnOperkinds